import { useState, useEffect } from 'react';
import { Card, Heading, Button, majorScale } from 'evergreen-ui';
import { EditIcon, CircleArrowLeftIcon } from 'evergreen-ui';
import CollaboratorList from './CollaboratorList';
import AddCollaboratorForm from './AddCollaboratorForm';
import { getCollaborators } from '../services/collaboratorServices';

const CollaborativeMembers = ({ collaborators, setCollaborators, isRealDirector }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newCollaborator, setNewCollaborator] = useState({ email: '', password: '', nome: '', cognome: '', role: '' });
    const [editingCollaboratorIndex, setEditingCollaboratorIndex] = useState(null);

    useEffect(() => {
        const fetchCollaborators = async () => {
            try {
                const collaboratorsData = await getCollaborators();
                setCollaborators(collaboratorsData);
            } catch (error) {
                console.error('Errore nel recupero dei collaboratori:', error);
            }
        };

        fetchCollaborators();
    }, [setCollaborators]);

    const handleExitEditMode = () => {
        setIsEditing(false);
        setEditingCollaboratorIndex(null);
    };

    if (!isEditing) {
        return (
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <Heading size={700} marginBottom={16}>
                    Collaboratori
                </Heading>
                <CollaboratorList
                    collaborators={collaborators}
                    setCollaborators={setCollaborators}
                    editingCollaboratorIndex={null}
                    setEditingCollaboratorIndex={() => {}}
                    isEditing={false}
                    isRealDirector={isRealDirector}
                />
                <Button appearance="primary" intent="success" marginTop={16} onClick={() => setIsEditing(true)}>
                    Modifica <EditIcon marginLeft={8} />
                </Button>
            </Card>
        );
    }

    return (
        <Card elevation={2} padding={24} marginBottom={32} background="tint1">
            <Heading size={700} marginBottom={16}>
                Gestione collaboratori
            </Heading>
            <CollaboratorList
                collaborators={collaborators}
                setCollaborators={setCollaborators}
                editingCollaboratorIndex={editingCollaboratorIndex}
                setEditingCollaboratorIndex={setEditingCollaboratorIndex}
                isEditing={true}
                isRealDirector={isRealDirector}
            />
            <AddCollaboratorForm
                newCollaborator={newCollaborator}
                setCollaborators={setCollaborators}
                setNewCollaborator={setNewCollaborator}
            />
            <Button appearance="primary" marginTop={majorScale(2)} onClick={handleExitEditMode} width="10.3rem">
                Torna indietro <CircleArrowLeftIcon marginLeft={8} />
            </Button>
        </Card>
    );
};

export default CollaborativeMembers;